import React from "react";
import { WizTableForm } from '@/containers/common'
import { mergeColumns } from '../../utils';

const user = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
const path = WizTableForm.Config.path(this, { apiParams: { state: 2 } })
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}
const position = WizTableForm.Config.position(this, {apiParams: {state: 1}})

//配置项
const componentName = "pathReport";

function columns() {
  const columns = [
    {
      title: "路径名称",
      name: 'pathId',
      searchItem: {
        ...path,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择路径名称'
          }
        ]
      }
    },
    {
      title: "路径阶段名称",
      name: 'pathStageIds',
      searchItem: {
        type: 'diy',
        links: {'pathId': '路径名称'},
        ...WizTableForm.Config.program(this, {}),
        changePopsFunction: (
          linksValues
        ) => {
          console.log("lllll:",linksValues)
          const { pathId } = linksValues
          config = WizTableForm.Config.pathStageReport(this, { apiParams: {trainPathId:pathId, state: 2 } })
          return config
        },
        diy: WizTableForm,
      },
    },
    {
      title: "路径名称",
      name: 'pathName',
      tableItem: {},
    },
    {
      title: "学员账号",
      name: 'account',
      tableItem: {}
    },
    {
      title: "学员姓名",
      name: 'fullName',
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: 'personIds',
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    {
      title: "账号状态",
      name: 'accountState',
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 1, codeName: '激活' },
        { code: 0, codeName: '禁用' },
      ]
    },
    {
      title: "学员任职信息",
      name: 'userIdentityInfos',
      tableItem: {
        type: 'popover'
      },
    },
    {
      title: "上级组织",
      name: 'leadName',
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "组织名称",
      name: 'orgName',
      tableItem: {},
    },
    {
      title: "组织名称",
      name: 'orgIds',
      searchItem: {
        ...organization,
        diy: WizTableForm,
        onChangeRowMap: (e) => {},
      },
    },
    {
      title: "组织编码",
      name: 'orgCode',
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryIds",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        treeCheckable: true
      }
    },
    {
      title: "省份",
      name: 'province',
      tableItem: {},
    },
    {
      title: "岗位",
      name: 'positionName',
      tableItem: {},
    },
    {
      title: "阶段名称",
      name: 'pathStageName',
      tableItem: {},
    },
    {
      title: "总成绩",
      name: 'score',
      tableItem: {},
    },
    {
      title: "省份",
      name: 'province',
      searchItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
  ];

  return mergeColumns.call(this, columns,[])
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          bordered: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListScoreDetail`,
    payload: {
      key: `${componentName}@getPageListScoreDetail`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportScoreStudentDetail`,
    payload: {
      key: `${componentName}@exportScoreStudentDetail`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `organizationNodeCategory@getTypeNodeList`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list",'orgNodeCategoryTree'],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
